import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSwapHoriz = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSwapHoriz",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m233-320 75 75q11 11 11 28t-11 28q-12 12-28 12t-29-12L108-332q-6-6-8-13t-3-15 3-15 8-13l144-144q12-12 28-11t28 12q11 12 12 28t-12 28l-75 75h247q17 0 29 12t11 28-11 29-29 11zm494-240H480q-17 0-28-11t-12-29 12-28 28-12h247l-75-75q-11-11-11-27t11-29q12-12 29-12t28 12l143 143q6 6 9 13t2 15-2 15-9 13L708-428q-12 12-28 12t-28-13q-11-12-11-28t11-28z"
  })
}));